import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MtvDrawer from "../mtv-drawer.component";
import TranscriptsContent from './transcripts-content';
class TranscriptsDrawer extends Component {
    constructor(props) {
        super(props);
        //console.log("[TranscriptsDrawer] props:",props);
    }


    componentDidUpdate(prevProps, prevState) {
        //console.log("[TranscriptsDrawer] Update:",this.props);
    }
    render() {

        const DrawerProps = {
            key: "mtv-transcripts-drawer",
            header: "Transcript",
            ...this.props
        }
        return (
            <MtvDrawer {...DrawerProps}>
                <TranscriptsContent content={this.props.content} onRendered={this.props.onContentRendered} imageServer={this.props.imageServer} />
            </MtvDrawer>
        )
    }
    static get propTypes() {
        return {
            content: PropTypes.string,
            onContentRendered: PropTypes.func,
            imageServer: PropTypes.object
        }
    }

}

export default TranscriptsDrawer;
